import { GenericCard } from '~src/app/spaces/CardView/GenericCard';
import { Messages } from '~src/codegen/Localize';
import { ExplorableItemDefinition, ContentTypeFilterClause } from '~src/contentDefinitionInterfaces/ContentDefinitionsTypes';
import { LocallySortingScheduleResourceQuery } from '~src/ts/helpers/LocallySortingScheduleResourceQuery';
import { ServerFilterClauses } from '~src/ts/helpers/ServerFilterClauses';
import { RemoteRefreshScheduleContentType } from '~src/ts/models/ContentTypes';
import { RemoteRefreshSchedules } from '~src/ts/resources/RemoteRefreshSchedules';

import { getGenericDefaultFilters } from './getDefaultFilters';

// TFS 829185
export const RemoteRefreshSchedulesDefinition: ExplorableItemDefinition = {
  itemType: 'remoteRefreshSchedule',
  pluralName: Messages.extractTasks,
  singularName: Messages.extractTask,
  emptyStateMessage: Messages.extractTasksEmptyMessage,
  contentFilterKeys: [],
  defaultFilters: getGenericDefaultFilters,
  cardComponent: GenericCard,
  listViewIconUrl: null,
  filterClause: ServerFilterClauses.ContentType(['remoteRefreshSchedule']) as ContentTypeFilterClause,
  getBasicQuery: () => {
    const resourceQuery = RemoteRefreshSchedules.all().withExtraParams(RemoteRefreshScheduleContentType.extraQueryParams);
    return new LocallySortingScheduleResourceQuery(resourceQuery);
  },
  getContentInfo: () => {
  },
  supportedDisplayModes: ['list'],
};
